import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const LIST_ITEM_STYLES =
  'flex flex-row list-none py-1 px-0 flex-shrink-0 flex-grow'

export interface ListItemProps {
  className?: string
  style?: React.CSSProperties
}

export const ListItem: React.FC<PropsWithChildren<ListItemProps>> = ({
  children,
  className,
  style,
}) => (
  <li className={concatStyles([LIST_ITEM_STYLES, className])} style={style}>
    {children}
  </li>
)

ListItem.displayName = 'Content.ListItem'
